/**
 * Created by Ning Jiang on 2024-04-17.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipS3Symbol} from "../../symbol/DeadwoodRipS3Symbol";
import {DeadwoodRipLSymbol} from "../../symbol/DeadwoodRipLSymbol";
import {DeadwoodRipSymbol} from "../../symbol/DeadwoodRipSymbol";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class S3LandingController extends ReelStopPresentationController {

    private _isAttentionPlaying:boolean;
    private _playingSymbols:DeadwoodRipSymbol[] = [];

    constructor() {
        super("S3LandingController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        if(data.reelId === 0 || data.reelId === 4) {
            return Promise.resolve();
        }

        if(data.reelId === 1 && DeadwoodRip.model.parsedGameData.S3Positions[1] > -1) {
            this._isAttentionPlaying = true;
            return Promise.all(
                [
                    this.playS3Attention(1, DeadwoodRip.model.parsedGameData.S3Positions[1]),
                    // this.playLowWildAttention(1)
                ]
            );
        }

        if(!this._isAttentionPlaying) {
            return Promise.resolve();
        }

        // if(data.reelId === 2) {
        //     return Promise.resolve(this.playLowWildAttention(2));
        // }

        if(data.reelId === 3) {
            this._isAttentionPlaying = false;
            const promises:Promise<void>[] = [];
            this.stopAllAttentions(); // TODO; set S3.isAttentionPlaying = false
            if(DeadwoodRip.model.parsedGameData.S3Positions[3] > -1) {
                // this.playLowWildAttention(3)
                promises.push(this.playS3Win(1, DeadwoodRip.model.parsedGameData.S3Positions[1]));
                promises.push(this.playS3Win(3, DeadwoodRip.model.parsedGameData.S3Positions[3]));
                DeadwoodRipSound.soundPlayer.playTrack({name: DeadwoodRipSound.BADGE2_LAND});
            }

            return Promise.all(promises);
        }

        return Promise.resolve();
    }

    private playS3Attention(reelId:number, symId:number):Promise<any> {
        const firstS3 = DeadwoodRip.reels[reelId].getSymbol(symId);
        this._playingSymbols.push(firstS3);
        DeadwoodRipSound.soundPlayer.playTrack({name: DeadwoodRipSound.BADGE1_LAND});
        return Promise.resolve((<DeadwoodRipS3Symbol>firstS3).playAttention());
    }

    // private playLowWildAttention(reelId:number):Promise<any> {
    //     const promises:Promise<any>[] = [];
    //     DeadwoodRip.model.parsedGameData.reels[reelId].forEach((symName, symId) => {
    //         if(symId === 0 || symId === 5) {
    //             return;
    //         }
    //         if(symName.includes("L")) {
    //             const sym = <DeadwoodRipLSymbol>DeadwoodRip.reels[reelId].getSymbol(symId - 1);
    //             this._playingSymbols.push(sym);
    //             promises.push(Promise.resolve(sym.playWildAttention()));
    //         }
    //     });
    //
    //     return Promise.all(promises);
    // }

    private stopAllAttentions():void {
        while(this._playingSymbols.length > 0) {
            const sym = this._playingSymbols.pop();
            if(sym instanceof DeadwoodRipS3Symbol) {
                sym.stopAttention();
            } else {
                (<DeadwoodRipLSymbol>sym).stopWildAttention();
            }
        }
    }

    private playS3Win(reelId:number, symId:number):Promise<any> {
        const sym = DeadwoodRip.reels[reelId].getSymbol(symId);
        return Promise.resolve((<DeadwoodRipS3Symbol>sym).playFeatureWin())
    }
}